module.exports = __webpack_public_path__ + "img/download.bd950d3.svg";